import React from 'react';

const Button = ({ label, onClick, className, icon, disabled }) => {
    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={`flex items-center gap-2 px-4 py-2 text-white bg-[#7494FF] hover:bg-blue-600 rounded-[200px] ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
        >
            {icon && <img src={icon} alt="" className="w-5 h-5" />}
            <div className="text-white text-xl font-semibold text-center w-full min-w-[88px]"> {label}</div>

        </button>
    );
};

export default Button;